/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminImpersonateCodeExchangeRequest,
  AdminImpersonateCodeExchangeResponse,
  AdminImpersonateRequest,
  AdminImpersonateResponse,
  AdminResetPasswordRequest,
  AdminResetPasswordResponse,
  AuthControllerLoginWithEmailAndPassword200Response,
  AuthControllerUserInfo200Response,
  ChallengeNewPasswordRequiredRequest,
  ChallengeNewPasswordRequiredResponse,
  ChangePasswordRequest,
  ConfirmResetPasswordRequest,
  CreateCompanyDto,
  DirectOAuth2AuthorizeResponse,
  GetOAuth2ClientInfoResponse,
  LoginWithEmailAndPasswordRequest,
  OAuth2TokenRequest,
  OAuth2TokenResponse,
  RefreshTokenResponse,
  SSOCodeExchangeRequest,
  SSOCodeExchangeResponse,
  StartResetPasswordRequest,
  StartResetPasswordResponse,
  UpdateCompanyDto,
} from '../models/index';
import {
    AdminImpersonateCodeExchangeRequestFromJSON,
    AdminImpersonateCodeExchangeRequestToJSON,
    AdminImpersonateCodeExchangeResponseFromJSON,
    AdminImpersonateCodeExchangeResponseToJSON,
    AdminImpersonateRequestFromJSON,
    AdminImpersonateRequestToJSON,
    AdminImpersonateResponseFromJSON,
    AdminImpersonateResponseToJSON,
    AdminResetPasswordRequestFromJSON,
    AdminResetPasswordRequestToJSON,
    AdminResetPasswordResponseFromJSON,
    AdminResetPasswordResponseToJSON,
    AuthControllerLoginWithEmailAndPassword200ResponseFromJSON,
    AuthControllerLoginWithEmailAndPassword200ResponseToJSON,
    AuthControllerUserInfo200ResponseFromJSON,
    AuthControllerUserInfo200ResponseToJSON,
    ChallengeNewPasswordRequiredRequestFromJSON,
    ChallengeNewPasswordRequiredRequestToJSON,
    ChallengeNewPasswordRequiredResponseFromJSON,
    ChallengeNewPasswordRequiredResponseToJSON,
    ChangePasswordRequestFromJSON,
    ChangePasswordRequestToJSON,
    ConfirmResetPasswordRequestFromJSON,
    ConfirmResetPasswordRequestToJSON,
    CreateCompanyDtoFromJSON,
    CreateCompanyDtoToJSON,
    DirectOAuth2AuthorizeResponseFromJSON,
    DirectOAuth2AuthorizeResponseToJSON,
    GetOAuth2ClientInfoResponseFromJSON,
    GetOAuth2ClientInfoResponseToJSON,
    LoginWithEmailAndPasswordRequestFromJSON,
    LoginWithEmailAndPasswordRequestToJSON,
    OAuth2TokenRequestFromJSON,
    OAuth2TokenRequestToJSON,
    OAuth2TokenResponseFromJSON,
    OAuth2TokenResponseToJSON,
    RefreshTokenResponseFromJSON,
    RefreshTokenResponseToJSON,
    SSOCodeExchangeRequestFromJSON,
    SSOCodeExchangeRequestToJSON,
    SSOCodeExchangeResponseFromJSON,
    SSOCodeExchangeResponseToJSON,
    StartResetPasswordRequestFromJSON,
    StartResetPasswordRequestToJSON,
    StartResetPasswordResponseFromJSON,
    StartResetPasswordResponseToJSON,
    UpdateCompanyDtoFromJSON,
    UpdateCompanyDtoToJSON,
} from '../models/index';

export interface AuthApiKeyControllerGetGoogleOAuthTokenRequest {
    userId: string;
}

export interface AuthControllerAdminImpersonateRequest {
    adminImpersonateRequest: AdminImpersonateRequest;
}

export interface AuthControllerAdminImpersonateCodeExchangeRequest {
    adminImpersonateCodeExchangeRequest: AdminImpersonateCodeExchangeRequest;
}

export interface AuthControllerAdminResetPasswordRequest {
    adminResetPasswordRequest: AdminResetPasswordRequest;
}

export interface AuthControllerBeginRequest {
    redirect?: string;
}

export interface AuthControllerCallbackRequest {
    code: string;
    state: string;
}

export interface AuthControllerChallengeResetPasswordRequiredRequest {
    challengeNewPasswordRequiredRequest: ChallengeNewPasswordRequiredRequest;
}

export interface AuthControllerChangePasswordRequest {
    changePasswordRequest: ChangePasswordRequest;
}

export interface AuthControllerConfirmResetPasswordRequest {
    confirmResetPasswordRequest: ConfirmResetPasswordRequest;
}

export interface AuthControllerGetOAuth2ClientInfoRequest {
    id: string;
}

export interface AuthControllerLoginWithEmailAndPasswordRequest {
    loginWithEmailAndPasswordRequest: LoginWithEmailAndPasswordRequest;
}

export interface AuthControllerOauth2AuthorizationUrlRequest {
    responseType: any;
    clientId: any;
    scope: any;
    redirectUri: any;
    state?: any;
}

export interface AuthControllerOauth2DirectAuthorizeRequest {
    responseType: any;
    clientId: any;
    scope: any;
    redirectUri: any;
    state?: any;
}

export interface AuthControllerOauth2tokenRequest {
    oAuth2TokenRequest: OAuth2TokenRequest;
}

export interface AuthControllerStartResetPasswordRequest {
    startResetPasswordRequest: StartResetPasswordRequest;
}

export interface AuthSSOControllerSsoCodeExchangeRequest {
    sSOCodeExchangeRequest: SSOCodeExchangeRequest;
}

export interface AuthSSOControllerSsoLoginStartRequest {
    plan: string;
    flow: AuthSSOControllerSsoLoginStartFlowEnum;
    debug: boolean;
    provider?: string;
    codeChallenge?: string;
    responseMode?: string;
}

export interface AuthSSOControllerSsoLoginStartAnyPlanRequest {
    provider: string;
    codeChallenge?: string;
    responseMode?: string;
}

export interface AuthSSOControllerSsoMetadataRequest {
    plan: string;
    provider?: string;
}

export interface CompanyControllerCreateRequest {
    createCompanyDto: CreateCompanyDto;
}

export interface CompanyControllerFindOneRequest {
    id: string;
}

export interface CompanyControllerRemoveRequest {
    id: string;
}

export interface CompanyControllerUpdateRequest {
    id: string;
    updateCompanyDto: UpdateCompanyDto;
}

/**
 * AuthApi - interface
 * 
 * @export
 * @interface AuthApiInterface
 */
export interface AuthApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authApiKeyControllerGetGoogleOAuthTokenRaw(requestParameters: AuthApiKeyControllerGetGoogleOAuthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    authApiKeyControllerGetGoogleOAuthToken(requestParameters: AuthApiKeyControllerGetGoogleOAuthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Admin impersonate user
     * @param {AdminImpersonateRequest} adminImpersonateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerAdminImpersonateRaw(requestParameters: AuthControllerAdminImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminImpersonateResponse>>;

    /**
     * Admin impersonate user
     */
    authControllerAdminImpersonate(requestParameters: AuthControllerAdminImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminImpersonateResponse>;

    /**
     * Exchange a one-time cross-brand admin-impersonation code for tokens.
     * @summary Admin impersonate code exchange
     * @param {AdminImpersonateCodeExchangeRequest} adminImpersonateCodeExchangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerAdminImpersonateCodeExchangeRaw(requestParameters: AuthControllerAdminImpersonateCodeExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminImpersonateCodeExchangeResponse>>;

    /**
     * Exchange a one-time cross-brand admin-impersonation code for tokens.
     * Admin impersonate code exchange
     */
    authControllerAdminImpersonateCodeExchange(requestParameters: AuthControllerAdminImpersonateCodeExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminImpersonateCodeExchangeResponse>;

    /**
     * 
     * @summary Admin reset password
     * @param {AdminResetPasswordRequest} adminResetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerAdminResetPasswordRaw(requestParameters: AuthControllerAdminResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminResetPasswordResponse>>;

    /**
     * Admin reset password
     */
    authControllerAdminResetPassword(requestParameters: AuthControllerAdminResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminResetPasswordResponse>;

    /**
     * OAuth2 begin
     * @summary OAuth2 begin
     * @param {string} [redirect] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerBeginRaw(requestParameters: AuthControllerBeginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * OAuth2 begin
     * OAuth2 begin
     */
    authControllerBegin(requestParameters: AuthControllerBeginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * OAuth2 callback. Exchange the authorization code for an access token.
     * @summary OAuth2 callback
     * @param {string} code 
     * @param {string} state 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerCallbackRaw(requestParameters: AuthControllerCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * OAuth2 callback. Exchange the authorization code for an access token.
     * OAuth2 callback
     */
    authControllerCallback(requestParameters: AuthControllerCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Auth challenge - New password required
     * @param {ChallengeNewPasswordRequiredRequest} challengeNewPasswordRequiredRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerChallengeResetPasswordRequiredRaw(requestParameters: AuthControllerChallengeResetPasswordRequiredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeNewPasswordRequiredResponse>>;

    /**
     * Auth challenge - New password required
     */
    authControllerChallengeResetPasswordRequired(requestParameters: AuthControllerChallengeResetPasswordRequiredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeNewPasswordRequiredResponse>;

    /**
     * 
     * @summary Change password for logged-in user
     * @param {ChangePasswordRequest} changePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerChangePasswordRaw(requestParameters: AuthControllerChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Change password for logged-in user
     */
    authControllerChangePassword(requestParameters: AuthControllerChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Confirm reset password
     * @param {ConfirmResetPasswordRequest} confirmResetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerConfirmResetPasswordRaw(requestParameters: AuthControllerConfirmResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Confirm reset password
     */
    authControllerConfirmResetPassword(requestParameters: AuthControllerConfirmResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get OAuth2 client by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerGetOAuth2ClientInfoRaw(requestParameters: AuthControllerGetOAuth2ClientInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOAuth2ClientInfoResponse>>;

    /**
     * Get OAuth2 client by ID
     */
    authControllerGetOAuth2ClientInfo(requestParameters: AuthControllerGetOAuth2ClientInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOAuth2ClientInfoResponse>;

    /**
     * Login with email and password
     * @summary Login
     * @param {LoginWithEmailAndPasswordRequest} loginWithEmailAndPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerLoginWithEmailAndPasswordRaw(requestParameters: AuthControllerLoginWithEmailAndPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthControllerLoginWithEmailAndPassword200Response>>;

    /**
     * Login with email and password
     * Login
     */
    authControllerLoginWithEmailAndPassword(requestParameters: AuthControllerLoginWithEmailAndPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthControllerLoginWithEmailAndPassword200Response>;

    /**
     * Logout
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerLogoutBeginRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Logout
     * Logout
     */
    authControllerLogoutBegin(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Logout callback
     * @summary Logout callback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerLogoutCallbackRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Logout callback
     * Logout callback
     */
    authControllerLogoutCallback(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * OAuth2 authorize
     * @summary OAuth2 authorize
     * @param {any} responseType Response type: code
     * @param {any} clientId The client identifier issued to the client during the registration process.
     * @param {any} scope The scope of the access request.
     * @param {any} redirectUri The URI to redirect to after authorization.
     * @param {any} [state] A value used by the client to maintain state between the request and callback.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerOauth2AuthorizationUrlRaw(requestParameters: AuthControllerOauth2AuthorizationUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * OAuth2 authorize
     * OAuth2 authorize
     */
    authControllerOauth2AuthorizationUrl(requestParameters: AuthControllerOauth2AuthorizationUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * OAuth2 direct authorize when logged in
     * @summary OAuth2 - direct authorize 
     * @param {any} responseType Response type: code
     * @param {any} clientId The client identifier issued to the client during the registration process.
     * @param {any} scope The scope of the access request.
     * @param {any} redirectUri The URI to redirect to after authorization.
     * @param {any} [state] A value used by the client to maintain state between the request and callback.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerOauth2DirectAuthorizeRaw(requestParameters: AuthControllerOauth2DirectAuthorizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DirectOAuth2AuthorizeResponse>>;

    /**
     * OAuth2 direct authorize when logged in
     * OAuth2 - direct authorize 
     */
    authControllerOauth2DirectAuthorize(requestParameters: AuthControllerOauth2DirectAuthorizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DirectOAuth2AuthorizeResponse>;

    /**
     * OAuth2 - request access token
     * @summary OAuth2 token
     * @param {OAuth2TokenRequest} oAuth2TokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerOauth2tokenRaw(requestParameters: AuthControllerOauth2tokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuth2TokenResponse>>;

    /**
     * OAuth2 - request access token
     * OAuth2 token
     */
    authControllerOauth2token(requestParameters: AuthControllerOauth2tokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuth2TokenResponse>;

    /**
     * OAuth2 refresh
     * @summary OAuth2 refresh
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerRefreshRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RefreshTokenResponse>>;

    /**
     * OAuth2 refresh
     * OAuth2 refresh
     */
    authControllerRefresh(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RefreshTokenResponse>;

    /**
     * 
     * @summary Start reset password
     * @param {StartResetPasswordRequest} startResetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerStartResetPasswordRaw(requestParameters: AuthControllerStartResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartResetPasswordResponse>>;

    /**
     * Start reset password
     */
    authControllerStartResetPassword(requestParameters: AuthControllerStartResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartResetPasswordResponse>;

    /**
     * User info
     * @summary User info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerUserInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthControllerUserInfo200Response>>;

    /**
     * User info
     * User info
     */
    authControllerUserInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthControllerUserInfo200Response>;

    /**
     * Exchange a one-time SSO code for tokens.
     * @summary SSO code exchange
     * @param {SSOCodeExchangeRequest} sSOCodeExchangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authSSOControllerSsoCodeExchangeRaw(requestParameters: AuthSSOControllerSsoCodeExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SSOCodeExchangeResponse>>;

    /**
     * Exchange a one-time SSO code for tokens.
     * SSO code exchange
     */
    authSSOControllerSsoCodeExchange(requestParameters: AuthSSOControllerSsoCodeExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SSOCodeExchangeResponse>;

    /**
     * SSO login
     * @summary SSO login callback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authSSOControllerSsoLoginCallbackRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * SSO login
     * SSO login callback
     */
    authSSOControllerSsoLoginCallback(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * SSO login
     * @summary SSO login callback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authSSOControllerSsoLoginCallbackPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * SSO login
     * SSO login callback
     */
    authSSOControllerSsoLoginCallbackPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * SSO login start
     * @summary SSO login start
     * @param {string} plan 
     * @param {'login' | 'subscription' | 'test'} flow 
     * @param {boolean} debug 
     * @param {string} [provider] 
     * @param {string} [codeChallenge] 
     * @param {string} [responseMode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authSSOControllerSsoLoginStartRaw(requestParameters: AuthSSOControllerSsoLoginStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * SSO login start
     * SSO login start
     */
    authSSOControllerSsoLoginStart(requestParameters: AuthSSOControllerSsoLoginStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Starts an SSO login without asserting the user\'s plan up front. The returned       user\'s own plan is validated (that it actually offers this provider) once their identity is       known.
     * @summary SSO login start (plan-agnostic)
     * @param {string} provider 
     * @param {string} [codeChallenge] 
     * @param {string} [responseMode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authSSOControllerSsoLoginStartAnyPlanRaw(requestParameters: AuthSSOControllerSsoLoginStartAnyPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Starts an SSO login without asserting the user\'s plan up front. The returned       user\'s own plan is validated (that it actually offers this provider) once their identity is       known.
     * SSO login start (plan-agnostic)
     */
    authSSOControllerSsoLoginStartAnyPlan(requestParameters: AuthSSOControllerSsoLoginStartAnyPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} plan 
     * @param {string} [provider] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authSSOControllerSsoMetadataRaw(requestParameters: AuthSSOControllerSsoMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    authSSOControllerSsoMetadata(requestParameters: AuthSSOControllerSsoMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {CreateCompanyDto} createCompanyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    companyControllerCreateRaw(requestParameters: CompanyControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    companyControllerCreate(requestParameters: CompanyControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    companyControllerFindAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    companyControllerFindAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    companyControllerFindOneRaw(requestParameters: CompanyControllerFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    companyControllerFindOne(requestParameters: CompanyControllerFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    companyControllerRemoveRaw(requestParameters: CompanyControllerRemoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    companyControllerRemove(requestParameters: CompanyControllerRemoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateCompanyDto} updateCompanyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    companyControllerUpdateRaw(requestParameters: CompanyControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    companyControllerUpdate(requestParameters: CompanyControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI implements AuthApiInterface {

    /**
     */
    async authApiKeyControllerGetGoogleOAuthTokenRaw(requestParameters: AuthApiKeyControllerGetGoogleOAuthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling authApiKeyControllerGetGoogleOAuthToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/auth/{userId}/google-oauth-token`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async authApiKeyControllerGetGoogleOAuthToken(requestParameters: AuthApiKeyControllerGetGoogleOAuthTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authApiKeyControllerGetGoogleOAuthTokenRaw(requestParameters, initOverrides);
    }

    /**
     * Admin impersonate user
     */
    async authControllerAdminImpersonateRaw(requestParameters: AuthControllerAdminImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminImpersonateResponse>> {
        if (requestParameters['adminImpersonateRequest'] == null) {
            throw new runtime.RequiredError(
                'adminImpersonateRequest',
                'Required parameter "adminImpersonateRequest" was null or undefined when calling authControllerAdminImpersonate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/admin-impersonate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminImpersonateRequestToJSON(requestParameters['adminImpersonateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminImpersonateResponseFromJSON(jsonValue));
    }

    /**
     * Admin impersonate user
     */
    async authControllerAdminImpersonate(requestParameters: AuthControllerAdminImpersonateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminImpersonateResponse> {
        const response = await this.authControllerAdminImpersonateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exchange a one-time cross-brand admin-impersonation code for tokens.
     * Admin impersonate code exchange
     */
    async authControllerAdminImpersonateCodeExchangeRaw(requestParameters: AuthControllerAdminImpersonateCodeExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminImpersonateCodeExchangeResponse>> {
        if (requestParameters['adminImpersonateCodeExchangeRequest'] == null) {
            throw new runtime.RequiredError(
                'adminImpersonateCodeExchangeRequest',
                'Required parameter "adminImpersonateCodeExchangeRequest" was null or undefined when calling authControllerAdminImpersonateCodeExchange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/admin-impersonate/code-exchange`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminImpersonateCodeExchangeRequestToJSON(requestParameters['adminImpersonateCodeExchangeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminImpersonateCodeExchangeResponseFromJSON(jsonValue));
    }

    /**
     * Exchange a one-time cross-brand admin-impersonation code for tokens.
     * Admin impersonate code exchange
     */
    async authControllerAdminImpersonateCodeExchange(requestParameters: AuthControllerAdminImpersonateCodeExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminImpersonateCodeExchangeResponse> {
        const response = await this.authControllerAdminImpersonateCodeExchangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin reset password
     */
    async authControllerAdminResetPasswordRaw(requestParameters: AuthControllerAdminResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminResetPasswordResponse>> {
        if (requestParameters['adminResetPasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'adminResetPasswordRequest',
                'Required parameter "adminResetPasswordRequest" was null or undefined when calling authControllerAdminResetPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/admin-reset-password`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminResetPasswordRequestToJSON(requestParameters['adminResetPasswordRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminResetPasswordResponseFromJSON(jsonValue));
    }

    /**
     * Admin reset password
     */
    async authControllerAdminResetPassword(requestParameters: AuthControllerAdminResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminResetPasswordResponse> {
        const response = await this.authControllerAdminResetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * OAuth2 begin
     * OAuth2 begin
     */
    async authControllerBeginRaw(requestParameters: AuthControllerBeginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['redirect'] != null) {
            queryParameters['redirect'] = requestParameters['redirect'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/begin`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * OAuth2 begin
     * OAuth2 begin
     */
    async authControllerBegin(requestParameters: AuthControllerBeginRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authControllerBeginRaw(requestParameters, initOverrides);
    }

    /**
     * OAuth2 callback. Exchange the authorization code for an access token.
     * OAuth2 callback
     */
    async authControllerCallbackRaw(requestParameters: AuthControllerCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling authControllerCallback().'
            );
        }

        if (requestParameters['state'] == null) {
            throw new runtime.RequiredError(
                'state',
                'Required parameter "state" was null or undefined when calling authControllerCallback().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/callback`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * OAuth2 callback. Exchange the authorization code for an access token.
     * OAuth2 callback
     */
    async authControllerCallback(requestParameters: AuthControllerCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authControllerCallbackRaw(requestParameters, initOverrides);
    }

    /**
     * Auth challenge - New password required
     */
    async authControllerChallengeResetPasswordRequiredRaw(requestParameters: AuthControllerChallengeResetPasswordRequiredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeNewPasswordRequiredResponse>> {
        if (requestParameters['challengeNewPasswordRequiredRequest'] == null) {
            throw new runtime.RequiredError(
                'challengeNewPasswordRequiredRequest',
                'Required parameter "challengeNewPasswordRequiredRequest" was null or undefined when calling authControllerChallengeResetPasswordRequired().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/challenge/new-password-required`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChallengeNewPasswordRequiredRequestToJSON(requestParameters['challengeNewPasswordRequiredRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeNewPasswordRequiredResponseFromJSON(jsonValue));
    }

    /**
     * Auth challenge - New password required
     */
    async authControllerChallengeResetPasswordRequired(requestParameters: AuthControllerChallengeResetPasswordRequiredRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeNewPasswordRequiredResponse> {
        const response = await this.authControllerChallengeResetPasswordRequiredRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change password for logged-in user
     */
    async authControllerChangePasswordRaw(requestParameters: AuthControllerChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['changePasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'changePasswordRequest',
                'Required parameter "changePasswordRequest" was null or undefined when calling authControllerChangePassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/change-password`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordRequestToJSON(requestParameters['changePasswordRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Change password for logged-in user
     */
    async authControllerChangePassword(requestParameters: AuthControllerChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authControllerChangePasswordRaw(requestParameters, initOverrides);
    }

    /**
     * Confirm reset password
     */
    async authControllerConfirmResetPasswordRaw(requestParameters: AuthControllerConfirmResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['confirmResetPasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'confirmResetPasswordRequest',
                'Required parameter "confirmResetPasswordRequest" was null or undefined when calling authControllerConfirmResetPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/confirm-reset-password`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmResetPasswordRequestToJSON(requestParameters['confirmResetPasswordRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirm reset password
     */
    async authControllerConfirmResetPassword(requestParameters: AuthControllerConfirmResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authControllerConfirmResetPasswordRaw(requestParameters, initOverrides);
    }

    /**
     * Get OAuth2 client by ID
     */
    async authControllerGetOAuth2ClientInfoRaw(requestParameters: AuthControllerGetOAuth2ClientInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOAuth2ClientInfoResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling authControllerGetOAuth2ClientInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/oauth2/client/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOAuth2ClientInfoResponseFromJSON(jsonValue));
    }

    /**
     * Get OAuth2 client by ID
     */
    async authControllerGetOAuth2ClientInfo(requestParameters: AuthControllerGetOAuth2ClientInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOAuth2ClientInfoResponse> {
        const response = await this.authControllerGetOAuth2ClientInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Login with email and password
     * Login
     */
    async authControllerLoginWithEmailAndPasswordRaw(requestParameters: AuthControllerLoginWithEmailAndPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthControllerLoginWithEmailAndPassword200Response>> {
        if (requestParameters['loginWithEmailAndPasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'loginWithEmailAndPasswordRequest',
                'Required parameter "loginWithEmailAndPasswordRequest" was null or undefined when calling authControllerLoginWithEmailAndPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/login`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginWithEmailAndPasswordRequestToJSON(requestParameters['loginWithEmailAndPasswordRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthControllerLoginWithEmailAndPassword200ResponseFromJSON(jsonValue));
    }

    /**
     * Login with email and password
     * Login
     */
    async authControllerLoginWithEmailAndPassword(requestParameters: AuthControllerLoginWithEmailAndPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthControllerLoginWithEmailAndPassword200Response> {
        const response = await this.authControllerLoginWithEmailAndPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Logout
     * Logout
     */
    async authControllerLogoutBeginRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/logout`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Logout
     * Logout
     */
    async authControllerLogoutBegin(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authControllerLogoutBeginRaw(initOverrides);
    }

    /**
     * Logout callback
     * Logout callback
     */
    async authControllerLogoutCallbackRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/logout-callback`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Logout callback
     * Logout callback
     */
    async authControllerLogoutCallback(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authControllerLogoutCallbackRaw(initOverrides);
    }

    /**
     * OAuth2 authorize
     * OAuth2 authorize
     */
    async authControllerOauth2AuthorizationUrlRaw(requestParameters: AuthControllerOauth2AuthorizationUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['responseType'] == null) {
            throw new runtime.RequiredError(
                'responseType',
                'Required parameter "responseType" was null or undefined when calling authControllerOauth2AuthorizationUrl().'
            );
        }

        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling authControllerOauth2AuthorizationUrl().'
            );
        }

        if (requestParameters['scope'] == null) {
            throw new runtime.RequiredError(
                'scope',
                'Required parameter "scope" was null or undefined when calling authControllerOauth2AuthorizationUrl().'
            );
        }

        if (requestParameters['redirectUri'] == null) {
            throw new runtime.RequiredError(
                'redirectUri',
                'Required parameter "redirectUri" was null or undefined when calling authControllerOauth2AuthorizationUrl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['responseType'] != null) {
            queryParameters['response_type'] = requestParameters['responseType'];
        }

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['redirectUri'] != null) {
            queryParameters['redirect_uri'] = requestParameters['redirectUri'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/oauth2/authorize`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * OAuth2 authorize
     * OAuth2 authorize
     */
    async authControllerOauth2AuthorizationUrl(requestParameters: AuthControllerOauth2AuthorizationUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authControllerOauth2AuthorizationUrlRaw(requestParameters, initOverrides);
    }

    /**
     * OAuth2 direct authorize when logged in
     * OAuth2 - direct authorize 
     */
    async authControllerOauth2DirectAuthorizeRaw(requestParameters: AuthControllerOauth2DirectAuthorizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DirectOAuth2AuthorizeResponse>> {
        if (requestParameters['responseType'] == null) {
            throw new runtime.RequiredError(
                'responseType',
                'Required parameter "responseType" was null or undefined when calling authControllerOauth2DirectAuthorize().'
            );
        }

        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling authControllerOauth2DirectAuthorize().'
            );
        }

        if (requestParameters['scope'] == null) {
            throw new runtime.RequiredError(
                'scope',
                'Required parameter "scope" was null or undefined when calling authControllerOauth2DirectAuthorize().'
            );
        }

        if (requestParameters['redirectUri'] == null) {
            throw new runtime.RequiredError(
                'redirectUri',
                'Required parameter "redirectUri" was null or undefined when calling authControllerOauth2DirectAuthorize().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['responseType'] != null) {
            queryParameters['response_type'] = requestParameters['responseType'];
        }

        if (requestParameters['clientId'] != null) {
            queryParameters['client_id'] = requestParameters['clientId'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['redirectUri'] != null) {
            queryParameters['redirect_uri'] = requestParameters['redirectUri'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/oauth2/direct-authorize`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DirectOAuth2AuthorizeResponseFromJSON(jsonValue));
    }

    /**
     * OAuth2 direct authorize when logged in
     * OAuth2 - direct authorize 
     */
    async authControllerOauth2DirectAuthorize(requestParameters: AuthControllerOauth2DirectAuthorizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DirectOAuth2AuthorizeResponse> {
        const response = await this.authControllerOauth2DirectAuthorizeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * OAuth2 - request access token
     * OAuth2 token
     */
    async authControllerOauth2tokenRaw(requestParameters: AuthControllerOauth2tokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OAuth2TokenResponse>> {
        if (requestParameters['oAuth2TokenRequest'] == null) {
            throw new runtime.RequiredError(
                'oAuth2TokenRequest',
                'Required parameter "oAuth2TokenRequest" was null or undefined when calling authControllerOauth2token().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/oauth2/token`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuth2TokenRequestToJSON(requestParameters['oAuth2TokenRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuth2TokenResponseFromJSON(jsonValue));
    }

    /**
     * OAuth2 - request access token
     * OAuth2 token
     */
    async authControllerOauth2token(requestParameters: AuthControllerOauth2tokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OAuth2TokenResponse> {
        const response = await this.authControllerOauth2tokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * OAuth2 refresh
     * OAuth2 refresh
     */
    async authControllerRefreshRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RefreshTokenResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/refresh`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefreshTokenResponseFromJSON(jsonValue));
    }

    /**
     * OAuth2 refresh
     * OAuth2 refresh
     */
    async authControllerRefresh(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RefreshTokenResponse> {
        const response = await this.authControllerRefreshRaw(initOverrides);
        return await response.value();
    }

    /**
     * Start reset password
     */
    async authControllerStartResetPasswordRaw(requestParameters: AuthControllerStartResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StartResetPasswordResponse>> {
        if (requestParameters['startResetPasswordRequest'] == null) {
            throw new runtime.RequiredError(
                'startResetPasswordRequest',
                'Required parameter "startResetPasswordRequest" was null or undefined when calling authControllerStartResetPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/start-reset-password`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StartResetPasswordRequestToJSON(requestParameters['startResetPasswordRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StartResetPasswordResponseFromJSON(jsonValue));
    }

    /**
     * Start reset password
     */
    async authControllerStartResetPassword(requestParameters: AuthControllerStartResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StartResetPasswordResponse> {
        const response = await this.authControllerStartResetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * User info
     * User info
     */
    async authControllerUserInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthControllerUserInfo200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/user-info`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthControllerUserInfo200ResponseFromJSON(jsonValue));
    }

    /**
     * User info
     * User info
     */
    async authControllerUserInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthControllerUserInfo200Response> {
        const response = await this.authControllerUserInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     * Exchange a one-time SSO code for tokens.
     * SSO code exchange
     */
    async authSSOControllerSsoCodeExchangeRaw(requestParameters: AuthSSOControllerSsoCodeExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SSOCodeExchangeResponse>> {
        if (requestParameters['sSOCodeExchangeRequest'] == null) {
            throw new runtime.RequiredError(
                'sSOCodeExchangeRequest',
                'Required parameter "sSOCodeExchangeRequest" was null or undefined when calling authSSOControllerSsoCodeExchange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/login/sso/code-exchange`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SSOCodeExchangeRequestToJSON(requestParameters['sSOCodeExchangeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SSOCodeExchangeResponseFromJSON(jsonValue));
    }

    /**
     * Exchange a one-time SSO code for tokens.
     * SSO code exchange
     */
    async authSSOControllerSsoCodeExchange(requestParameters: AuthSSOControllerSsoCodeExchangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SSOCodeExchangeResponse> {
        const response = await this.authSSOControllerSsoCodeExchangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * SSO login
     * SSO login callback
     */
    async authSSOControllerSsoLoginCallbackRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/login/sso/callback`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * SSO login
     * SSO login callback
     */
    async authSSOControllerSsoLoginCallback(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authSSOControllerSsoLoginCallbackRaw(initOverrides);
    }

    /**
     * SSO login
     * SSO login callback
     */
    async authSSOControllerSsoLoginCallbackPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/login/sso/callback`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * SSO login
     * SSO login callback
     */
    async authSSOControllerSsoLoginCallbackPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authSSOControllerSsoLoginCallbackPostRaw(initOverrides);
    }

    /**
     * SSO login start
     * SSO login start
     */
    async authSSOControllerSsoLoginStartRaw(requestParameters: AuthSSOControllerSsoLoginStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['plan'] == null) {
            throw new runtime.RequiredError(
                'plan',
                'Required parameter "plan" was null or undefined when calling authSSOControllerSsoLoginStart().'
            );
        }

        if (requestParameters['flow'] == null) {
            throw new runtime.RequiredError(
                'flow',
                'Required parameter "flow" was null or undefined when calling authSSOControllerSsoLoginStart().'
            );
        }

        if (requestParameters['debug'] == null) {
            throw new runtime.RequiredError(
                'debug',
                'Required parameter "debug" was null or undefined when calling authSSOControllerSsoLoginStart().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['codeChallenge'] != null) {
            queryParameters['code_challenge'] = requestParameters['codeChallenge'];
        }

        if (requestParameters['responseMode'] != null) {
            queryParameters['response_mode'] = requestParameters['responseMode'];
        }

        if (requestParameters['flow'] != null) {
            queryParameters['flow'] = requestParameters['flow'];
        }

        if (requestParameters['debug'] != null) {
            queryParameters['debug'] = requestParameters['debug'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/login/sso/{plan}/start`;
        urlPath = urlPath.replace(`{${"plan"}}`, encodeURIComponent(String(requestParameters['plan'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * SSO login start
     * SSO login start
     */
    async authSSOControllerSsoLoginStart(requestParameters: AuthSSOControllerSsoLoginStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authSSOControllerSsoLoginStartRaw(requestParameters, initOverrides);
    }

    /**
     * Starts an SSO login without asserting the user\'s plan up front. The returned       user\'s own plan is validated (that it actually offers this provider) once their identity is       known.
     * SSO login start (plan-agnostic)
     */
    async authSSOControllerSsoLoginStartAnyPlanRaw(requestParameters: AuthSSOControllerSsoLoginStartAnyPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['provider'] == null) {
            throw new runtime.RequiredError(
                'provider',
                'Required parameter "provider" was null or undefined when calling authSSOControllerSsoLoginStartAnyPlan().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['codeChallenge'] != null) {
            queryParameters['code_challenge'] = requestParameters['codeChallenge'];
        }

        if (requestParameters['responseMode'] != null) {
            queryParameters['response_mode'] = requestParameters['responseMode'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/login/sso/start`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Starts an SSO login without asserting the user\'s plan up front. The returned       user\'s own plan is validated (that it actually offers this provider) once their identity is       known.
     * SSO login start (plan-agnostic)
     */
    async authSSOControllerSsoLoginStartAnyPlan(requestParameters: AuthSSOControllerSsoLoginStartAnyPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authSSOControllerSsoLoginStartAnyPlanRaw(requestParameters, initOverrides);
    }

    /**
     */
    async authSSOControllerSsoMetadataRaw(requestParameters: AuthSSOControllerSsoMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['plan'] == null) {
            throw new runtime.RequiredError(
                'plan',
                'Required parameter "plan" was null or undefined when calling authSSOControllerSsoMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/auth/login/sso/{plan}/metadata`;
        urlPath = urlPath.replace(`{${"plan"}}`, encodeURIComponent(String(requestParameters['plan'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async authSSOControllerSsoMetadata(requestParameters: AuthSSOControllerSsoMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authSSOControllerSsoMetadataRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companyControllerCreateRaw(requestParameters: CompanyControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createCompanyDto'] == null) {
            throw new runtime.RequiredError(
                'createCompanyDto',
                'Required parameter "createCompanyDto" was null or undefined when calling companyControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/companies`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCompanyDtoToJSON(requestParameters['createCompanyDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companyControllerCreate(requestParameters: CompanyControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companyControllerCreateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companyControllerFindAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/companies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companyControllerFindAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companyControllerFindAllRaw(initOverrides);
    }

    /**
     */
    async companyControllerFindOneRaw(requestParameters: CompanyControllerFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling companyControllerFindOne().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/companies/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companyControllerFindOne(requestParameters: CompanyControllerFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companyControllerFindOneRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companyControllerRemoveRaw(requestParameters: CompanyControllerRemoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling companyControllerRemove().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/companies/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companyControllerRemove(requestParameters: CompanyControllerRemoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companyControllerRemoveRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companyControllerUpdateRaw(requestParameters: CompanyControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling companyControllerUpdate().'
            );
        }

        if (requestParameters['updateCompanyDto'] == null) {
            throw new runtime.RequiredError(
                'updateCompanyDto',
                'Required parameter "updateCompanyDto" was null or undefined when calling companyControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/companies/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCompanyDtoToJSON(requestParameters['updateCompanyDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companyControllerUpdate(requestParameters: CompanyControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companyControllerUpdateRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const AuthSSOControllerSsoLoginStartFlowEnum = {
    Login: 'login',
    Subscription: 'subscription',
    Test: 'test'
} as const;
export type AuthSSOControllerSsoLoginStartFlowEnum = typeof AuthSSOControllerSsoLoginStartFlowEnum[keyof typeof AuthSSOControllerSsoLoginStartFlowEnum];
